import _defineProperty from "/opt/jenkins_worker/workspace/zbcloud-master-\u4EBA\u5458\u5B9A\u4F4D/zbcloud-unify-auth-pro-hyc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
import { KeepAlive, defineComponent, isRef, useAttrs, useSlots } from "vue";
import { useRoute } from "vue-router";
import router from '@/router';
export default class Render {
  constructor() {
    _defineProperty(this, "name", '');
    _defineProperty(this, "defineProps", []);
    _defineProperty(this, "defineEmits", {});
    _defineProperty(this, "props", {});
    _defineProperty(this, "route", {});
    _defineProperty(this, "attrs", {});
    _defineProperty(this, "emit", {});
    _defineProperty(this, "slots", {});
    _defineProperty(this, "tailwindClass", {});
    _defineProperty(this, "context", void 0);
  }
  // emits = ():SetupContext['slots']
  onSetup(props, context) {}
  onCreated() {}
  onMounted() {}
  onUnmounted() {}
  onBeforeUpdate() {}
  OnUpdated() {}
  OnBeforeMount() {}
  onActivated() {}
  onDeactivated() {}
  onBeforeUnmount() {}
  render() {
    return _createVNode("div", null, null);
  }
  export() {
    return defineComponent({
      name: this.name || this.constructor.name,
      props: ['lock', ...this.defineProps],
      emits: this.defineEmits,
      created: () => {
        this.onCreated?.();
      },
      beforeMount: () => {
        this.OnBeforeMount?.();
      },
      mounted: () => {
        this.onMounted?.();
      },
      unmounted: () => {
        this.onUnmounted?.();
      },
      beforeUpdate: () => {
        this.onBeforeUpdate?.();
      },
      updated: () => {
        this.OnUpdated?.();
      },
      activated: () => {
        this.onActivated?.();
      },
      deactivated: () => {
        this.onDeactivated?.();
      },
      beforeUnmount: () => {
        this.onBeforeUnmount?.();
      },
      setup: (props, context) => {
        this.props = props;
        this.context = context;
        this.emit = context.emit.bind(this.context);
        return this.onSetup?.(props, context);
      },
      render: setup => {
        // 挂载插槽
        this.slots = useSlots.call(setup);
        // 挂载属性
        this.attrs = useAttrs.call(setup);
        // 挂载路由参数
        this.route = useRoute.call(setup);
        return this.render();
      }
    });
  }
  static export(item, content, other) {
    // 生成唯一key
    const name = this.name;
    const route = router.currentRoute.value;
    // 无缓存组件时处理
    const El = new this().export();
    const Dom = _createVNode(El, _mergeProps(item, {
      "ref": v => {
        if (isRef(item.refEl)) {
          item.refEl.value = v;
        } else if (typeof item.refEl === 'function') {
          item.refEl(v);
        } else if (item.refEl) {
          item.refEl = v;
        }
      }
    }), null);
    return route.meta.KeepAlive ? _createVNode(KeepAlive, null, [Dom]) : Dom;
  }
}
_defineProperty(Render, "defineProps", []);
_defineProperty(Render, "defineEmits", {});